import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true, // Enable sending cookies with requests
});

// Note: Tokens are now stored in HttpOnly cookies set by the backend
// No need to manually add Authorization header - cookies are sent automatically

// Handle 401 and Pro-required 403 responses
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    // Don't retry auth endpoints
    const url = error.config?.url || '';
    const isAuthEndpoint = ['/api/auth/me', '/api/auth/login', '/api/auth/refresh', '/api/auth/logout', '/api/auth/change-password'].some((p) => url.includes(p));
    if (error.response?.status === 401 && !isAuthEndpoint) {
      // Token expired or invalid - cookies will be cleared by backend
      // Redirect to login will be handled by the component
    }
    // Pro-required 403: signal AuthContext to re-check entitlement
    if (error.response?.status === 403 && !isAuthEndpoint) {
      const detail = error.response?.data?.detail;
      if (detail?.trial_ended === true) {
        window.dispatchEvent(new CustomEvent('pro-access-required'));
      }
    }
    return Promise.reject(error);
  }
);

// Legacy functions kept for backward compatibility during migration
// These are no-ops now since tokens are in HttpOnly cookies
export function setAuthToken(token) {
  // No-op: Tokens are now stored in HttpOnly cookies by the backend
  // Keeping this function to avoid breaking existing code
}

export function getAuthToken() {
  // No-op: Tokens are in HttpOnly cookies and cannot be accessed from JavaScript
  // This is a security feature to prevent XSS attacks
  return null;
}

export function formatApiError(detail) {
  if (detail == null) return 'Something went wrong.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg || JSON.stringify(e))).join(' ');
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
